<template>
    <div class="filter" :class="{focus,filled}" v-on-clickaway="handleBlur">
        <font-awesome-icon icon="search" @click.stop="setFocus" />
        <input ref="input" type="text" v-model="Ifilter" :placeholder="''" debounce="500" @focus.stop="focus = true"/>
        <font-awesome-icon icon="times" :class="{show:Ifilter.length > 0}" @click.stop="clearFilter"/>
    </div>
</template>

<script>
    import debounce from 'lodash/debounce'
    import {mixin as clickaway} from 'vue-clickaway';



    export default {
        name: 'FilterField',
        props: ['filter'],
        mixins: [clickaway],
        data: () => ({
            Ifilter: '',
            focus: false,
            filled: false,
            firstTime: true,
        }),
        watch: {
            Ifilter: function (value) {
                if(value == ''){
                    this.filled = false
                }
                else{
                    this.filled = true
                }
                this.emitFilter(value);
            }
        },
        methods: {
            emitFilter: debounce(function (value) {
                this.$emit('filter',value);
            }, 500),

            clearFilter: function(){
                this.Ifilter = '';
                this.focus = false;
                this.filled = false;
            },
            setFocus(){
                if(this.firstTime){
                    this.firstTime = false
                    this.focus = true;
                    setTimeout(() => {
                        this.$refs.input.focus();
                    },300)
                }


            },
            handleBlur(){
                if(!this.firstTime){
                    this.focus = false;
                    this.firstTime = true;
                }
                else{
                    this.firstTime = false;
                }


            }

        }
    }
</script>

<style lang="scss">
    .filter{
        background-color: $main-white;
        height: $filter-height + 2px;
        padding: 0 15px;
        position: relative;
        //box-shadow: 0 2px 10px rgba(0,0,0,0.08);
        z-index: 10;
        //border-bottom: solid 2px $main-color;


        .fa-search{
            color: darken($second-grey,40%);
            font-size: 1.5rem;
            height: 100%;
            line-height: $filter-height;
            vertical-align: middle;
        }

        .fa-times{
            color: darken($second-grey,40%);
            cursor: pointer;
            font-size: 1.5rem;
            line-height: $filter-height;
            opacity: 0;
            position: absolute;
            right: 15px;
            height: 100%;
            transition-property: opacity;
            vertical-align: middle;

            &.show{
                opacity: 1;
            }
        }

        input{
            border: none;
            background-color: transparent;
            color: darken($second-grey,40%);
            line-height: $filter-height;
            margin-left: 10px;
            width: calc(100% - 70px);

            &:focus{
                outline:none;
            }
        }

        &.with-type-filters{
            .fa-times{
                right: (4 * ($filter-height/1.1)) + 15px;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/ui/Filter.vue